import React, { MouseEvent } from 'react';
import _ from 'lodash';

import { Button } from '@tradingblock/components';
import { useDispatcher } from '../../../../data/global/hooks';
import { AdminEntitlementsActions } from '../../../../data/global/actions/admin/EntitlementsActions';
import { useBlockId } from '../../../../components/blocks/BlockState';

export const AdminEntitlementsFooter: React.FunctionComponent<{}> = () => {
  const { dispatch } = useDispatcher();
  const blockId = useBlockId();

  const handleClick = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    e.preventDefault();
    dispatch(AdminEntitlementsActions.clearSelectedEntitlementId({ blockId }));
  };

  return (
    <div className="screen-footer screen-footer-justified">
      <div className="d-flex align-items-center justify-content-center">
        <Button className="btn btn-blend" onClick={e => handleClick(e)}>
          <i className="fal fa-arrow-left" />
          Go back
        </Button>
      </div>
    </div>
  );
};
